module.exports = __webpack_public_path__ + "img/log-in.bf8bc49f.svg";